import Delete from "@mui/icons-material/Delete";
import Grid2 from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import React from "react";
import { CustomSchemaField } from "../../../interfaces/doc";
import { getFieldPath } from "../../Common/SchemaUtils";
import { getField } from "./ResultFormUtils";

const getCustomFormField = (custom_schema: CustomSchemaField[]) => {
  const CustomFormFields: React.FC<{
    extractionId: string;
    extractionPath?: string;
    label?: string;
    remove?: Function;
  }> = ({ extractionId, extractionPath, remove }) => {
    return (
      <Grid2
        container
        spacing={2}
        key={getFieldPath([extractionId, extractionPath])}
        sx={{ alignItems: "center" }}
      >
        <Grid2 size={remove !== undefined ? 11 : 12}>
          <Stack spacing={1}>
            {custom_schema.map(({ name, parsing_type, enum_values }) => {
              const FormField = getField(parsing_type, null, enum_values);
              return (
                <FormField
                  key={getFieldPath([extractionPath, name])}
                  extractionId={extractionId}
                  extractionPath={getFieldPath([extractionPath, name])}
                  label={name}
                />
              );
            })}
          </Stack>
        </Grid2>
        {remove !== undefined && (
          <Grid2 size={1} sx={{ textAlign: "right" }}>
            <IconButton
              onClick={() => {
                remove();
              }}
              className="rounded-full"
              size="small"
            >
              <Delete color="error" />
            </IconButton>
          </Grid2>
        )}
      </Grid2>
    );
  };
  return CustomFormFields;
};
export default getCustomFormField;
